<template>
  <v-popover :auto-hide="true">
    <template v-if="type === 'price'">
      <button
        @click="getData()"
        class="btn btn-xs btn-default"
      ><i class="icon-fa icon-fa-balance-scale"/>
      </button>
    </template>
    <template v-else>
      <button
        @click="getData()"
        :class="{'btn btn-xs border-r-0': true, 'btn-danger': trend > 0, 'btn-success': trend < 0, 'btn-default': trend === 0}"
      >
        <!--      style="height: 38px"-->
        <i class="icon-fa icon-fa-angle-double-down" v-if="trend < 0"/>
        <i class="icon-fa icon-fa-angle-double-up" v-if="trend > 0"/>
        <i class="icon-fa icon-fa-exchange" v-if="trend === 0"/>
      </button>
    </template>

    <template slot="popover">
      <template v-if="!loading">
        <div v-if="(loadedData ?? []).length">
          <table class="table popover_table_store_trends table-sm table-hover">
            <tbody>
            <tr v-for="r in loadedData">
              <td>{{ printDate(r.date, 'DD.MM.YYYY') }}</td>
              <td><strong>{{ type === 'price' ? r.price : r.stores }}</strong></td>
            </tr>
            </tbody>
          </table>
        </div>
        <div v-else>
          Нет данных
        </div>
      </template>
      <template v-else>
        Загрузка ....
      </template>
      <div class="mt-1 text-right">
        <button v-close-popover class="btn btn-theme btn-sm">
          Закрыть
        </button>
      </div>
    </template>
  </v-popover>
</template>
<script>

import api from "@/api";

export default {
  props: ['record', 'trend', 'type'],
  data() {
    return {
      loading: false,
      loadedData: null,
    }
  },
  methods: {
    async getData() {
      console.log('get');
      this.loading = true;
      const {data} = await api.index('/statistics/003/drug/trend/' + (this.record.stats_record_id ?? this.record.id) + '?type=' + this.type);
      if (data.success) {
        this.loadedData = data.records;
      } else {
        toastr['warning'](data.message ?? 'ошибка сервера', 'Неуспешно')
      }
      this.loading = false;
    }
  }
}

</script>

<style>
.popover_table_store_trends.table td {
  padding: 2px;
}
</style>
